import BigNumber from "bignumber.js";

export const LS = {
  THEME: "theme",
  CONNECTOR: "connector",
  CHAIN_ID: "chainId",
  FAVORITE_TOKEN: "scoring_favorite_token",
  NONCE: "scoring_nonce",
  AUTHORIZATION: "scoring_authorization",
};

export const THEME_MODE = {
  DARK: "dark",
  LIGHT: "light",
};

export const HOLDER = {
  OVERALL: "overall",
  ORAI: "orai",
  DFYN: "dfyn",
};

export const NETWORK = {
  BSC_MAINNET: "bsc_mainnet",
  FTM_MAINNET: "ftm_mainnet",
  ETH_MAINNET: "eth_mainnet",
  BSC_TESTNET: "bsc_testnet",
};

export const FS = {
  INITIAL: "INITIAL",
  FETCHING: "FETCHING",
  SUCCESS: "SUCCESS",
  FAIL: "FAIL",
  UPDATING: "UPDATING",
};

export const DATEPICKER_PREDEFINED = [
  { text: "Last 7 days", value: 7 },
  { text: "Last 14 days", value: 14 },
  { text: "Last 30 days", value: 30 },
  { text: "Last 60 days", value: 60 },
  { text: "Last 90 days", value: 90 },
];

export const PAGINATION_OPTION = [10, 15, 20, 30, 50, 100];
export const DEFAULT_ADDRESS = "0x0000000000000000000000000000000000000000";

export const BASE8 = BigNumber("100000000");
export const BASE18 = BigNumber("1000000000000000000");
export const ONE_RAY = 10 ** 27;

export const SCORING_BASE_ROOT_URL = "https://scoringapi.trava.finance";

export const detailChartConfig = [
  {
    title: "Price Score",
    types: ["price_over_highest_score_history", "price_history"],
  },
  {
    title: "Price Stability Score",
    types: ["price_stability_score_history", "price_stability_history"],
  },
  {
    title: "Number Of Transactions Score",
    types: ["number_of_transaction_score_history", "daily_transaction_history"],
  },
  {
    title: "Market Cap Score",
    types: ["market_cap_score_history", "market_cap_history"],
  },
  {
    title: "Trading Volume Score",
    types: ["trading_score_history", "trading_volume_24h_history"],
  },
  {
    title: "Holders Score",
    types: ["holders_score_history", "holder_history"],
  },
  {
    title: "Holder Distribution Score",
    types: ["holder_distribution_score_history", "holder_distribution_history"],
  },
];

export const portfolioChartConfig = [
  {
    title: "Price",
    types: "price_history",
  },
  {
    title: "Trading Volume",
    types: "trading_volume_24h_history",
  },
  {
    title: "Market Cap",
    types: "market_cap_history",
  },
  {
    title: "Number Of Transactions",
    types: "daily_transaction_history",
  },

  {
    title: "Number Of Holders",
    types: "holder_history",
  },
];

export const tokenHistoryTitles = {
  credit_score_history: "Health Score",
  market_cap_score_history: "Market Cap Score",
  market_cap_history: "Market Cap($)",
  price_over_highest_score_history: "Price Score",
  price_history: "Price($)",
  number_of_transaction_score_history: "Number Of Transactions Score",
  daily_transaction_history: "Number Of Transactions",
  trading_score_history: "Trading Volume Score",
  trading_volume_24h_history: "Trading Volume($)",
  holder_distribution_score_history: "Holder Distribution Score",
  holder_distribution_history: "Holder Distribution",
  holders_score_history: "Holders Score",
  holder_history: "Number Of Holders",
  price_stability_score_history: "Price Stability Score",
  price_stability_history: "Price Stability",
};

export const SUB_TYPE = {
  SUPPLY: "supply",
  BORROW: "borrow",
  TVL: "tvl",
};

export const INTEREST_TYPE = {
  DEPOSIT: "deposit",
  BORROW: "borrow",
};

export const MONITORING = {
  OVERVIEW: {
    marketOverview: "marketOverview",
    tokenDomination: "tokenDomination",
    utilizationRate: "utilizationRate",
    interestRate: "interestRate",
    numberOfTransactions: "numberOfTransactions",
    transactionVolume: "transactionVolume",
  },
  ANALYSIS: {
    userActiveness: "userActiveness",
    nourTransactionTypes: "nourTransactionTypes",
    nourTransactionVolume: "nourTransactionVolume",
    topUsers: "topUsers",
  },
  USER: {
    assetOverview: "assetOverview",
    liquidationHistory: "liquidationHistory",
    totalValueLocked: "totalValueLocked",
    transactionHistory: "transactionHistory",
  },
};
